const addInfo = {
  title: 'DriverCare',
  icon: 'checklist'
}
const driverCareRouter = {
  path: '/driver-care',
  meta: {
    title: 'DriverCare',
    icon: 'checklist',
    permission: ['driver_care_app']
  },
  children: [
    {
      path: 'driver-care-dashboard',
      component: () => import('@/views/DriverCare/DriverCareDashboard/driver-care-dashboard'),
      name: 'DriverCareDashboard',
      meta: { title: 'DriverCareDashboard', parent: addInfo,  permission: ['driver_care_app'] }
    },
    {
      path: 'check-in-out',
      component: () => import('@/views/DriverCare/CheckInOutRecord/check-in-out'),
      name: 'CheckInOut',
      meta: { title: 'CheckInOut', parent: addInfo, permission: ['driver_care_app_check_in_out_enable'] }
    },
    {
      path: 'checklist-approval',
      component: () => import('@/views/DriverCare/ChecklistApproval/checklist-approval'),
      name: 'ChecklistApproval',
      meta: { title: 'ChecklistApproval', parent: addInfo, permission: ['driver_care_app_checklist_enable'] }
    },
    // {
    //   path: 'driver-claim-report',
    //   component: () => import('@/views/DriverCare/DriverClaimReport/driver-claim-report'),
    //   name: 'DriverClaimReport',
    //   meta: { title: 'DriverClaimReport', parent: addInfo }
    // },
    {
      path: 'driver-tracing',
      component: () => import('@/views/DriverCare/DriverTracing/driver-tracing'),
      name: 'DriverTracing',
      meta: { title: 'DriverTracing', parent: addInfo, permission: ['driver_care_app_driver_tracing_enable'] }
    },
    {
      path: 'tools',
      name: 'DriverTools',
      meta: { 
        title: 'Tools', 
        permission: ['driver_care_app_tool_checklist_template_enable', 'driver_care_app_tool_driver_configuration_enable', 'driver_care_app_tool_checklist_item_enable']
      },
      children: [
        {
          path: 'driver-configuration',
          component: () => import('@/views/DriverCare/Tools/DriverConfiguration/driver-configuration'),
          name: 'DriverConfiguration',
          meta: { title: 'DriverConfiguration', parent: addInfo, permission: ['driver_care_app_tool_driver_configuration_enable']}
        },
        {
          path: 'driver-configuration-form/:id?',
          component: () => import('@/views/DriverCare/Tools/DriverConfiguration/driver-configuration-form'),
          name: 'DriverConfigurationForm',
          hidden: true,
          meta: { title: 'DriverConfigurationForm', parent: addInfo, activeMenu: '/driver-care/driver-configuration', enableBack: true, backPage: 'DriverConfiguration', permission: ['driver_care_app_tool_driver_configuration_item_create'] }
        },
        {
          path: 'update-driver-configuration-form/:id?',
          component: () => import('@/views/DriverCare/Tools/DriverConfiguration/driver-configuration-form'),
          name: 'UpdateDriverConfigurationForm',
          hidden: true,
          meta: { title: 'UpdateDriverConfigurationForm', parent: addInfo, activeMenu: '/driver-care/driver-configuration', enableBack: true, backPage: 'DriverConfiguration', permission: ['driver_care_app_tool_driver_configuration_item_update'] }
        },
        {
          path: 'view-driver-configuration-form/:id?',
          component: () => import('@/views/DriverCare/Tools/DriverConfiguration/driver-configuration-view'),
          name: 'ViewDriverConfiguration',
          hidden: true,
          meta: { title: 'ViewDriverConfiguration', parent: addInfo, activeMenu: '/driver-care/driver-configuration', enableBack: true, backPage: 'DriverConfiguration', permission: ['driver_care_app_tool_driver_configuration_enable'] }
        },
        {
          path: 'checklist-item-list',
          component: () => import('@/views/DriverCare/Tools/ChecklistItem/checklist-item-list'),
          name: 'ChecklistItem',
          meta: { title: 'ChecklistItem', parent: addInfo, permission: ['driver_care_app_tool_checklist_item_enable']}
        },
        {
          path: 'manage-checklist',
          component: () => import('@/views/DriverCare/ManageChecklist/manage-checklist'),
          name: 'ChecklistTemplate',
          meta: { title: 'ChecklistTemplate', parent: addInfo, permission: ['driver_care_app_tool_checklist_template_enable'] }
        },
        {
            path: 'create-checklist-template-form',
            component: () => import('@/views/DriverCare/ManageChecklist/checklist-template-form.vue'),
            name: 'ChecklistTemplateForm',
            hidden: true,
            meta: { 
                title: 'ChecklistTemplateForm', 
                activeMenu: '/DriverCare/manage-checklist',         
                enableBack: true,
                backPage: 'ChecklistTemplate',
                parent: addInfo,
                parentIcon: 'checklist',
                permission: ['driver_care_app_tool_checklist_template_create']
            }
        },
        {
            path: 'update-checklist-template-form/:id?',
            component: () => import('@/views/DriverCare/ManageChecklist/checklist-template-form.vue'),
            name: 'UpdateChecklistTemplateForm',
            hidden: true,
            meta: { 
                title: 'UpdateChecklistTemplateForm', 
                activeMenu: '/DriverCare/manage-checklist',          
                enableBack: true,
                backPage: 'ChecklistTemplate',
                parent: addInfo,
                parentIcon: 'checklist',
                permission: ['driver_care_app_tool_checklist_template_update']
            }
        },
      ]
    }
    // {
    //   path: 'driver-care-dashboard',
    //   component: () => import('@/views/driver/DriverApp/checklist-approval'),
    //   name: 'DriverCareDashboard',
    //   meta: { title: 'DriverCareDashboard', parent: addInfo,  permission: ['driver_care_app'] }
    // }, //yh got do b4 le check driverApp
    // {
    //   path: 'create-driver-form/:id?',
    //   component: () => import('@/views/driver/ManageDriver/manage-driver-form'),
    //   name: 'DriverForm',
    //   hidden: true,
    //   meta: { 
    //     title: 'ManageDriverForm', 
    //     parent: addInfo, 
    //     activeMenu: '/driver/manage-driver', 
    //     enableBack: true, 
    //     backPage: 'ManageDriver', 
    //     permission: ['driver_create', 'driver_care_app'] }
    // },
    // {
    //   path: 'update-driver-form/:id?',
    //   component: () => import('@/views/driver/ManageDriver/manage-driver-form'),
    //   name: 'UpdateDriverForm',
    //   hidden: true,
    //   meta: { 
    //     title: 'ManageDriverForm', 
    //     parent: addInfo, 
    //     activeMenu: '/driver/manage-driver', 
    //     enableBack: true, 
    //     backPage: 'ManageDriver', 
    //     permission: ['driver_update', 'driver_care_app'] }
    // },
    // {
    //   path: 'driver-details/:id',
    //   component: () => import('@/views/driver/ManageDriver/driver-details'),
    //   name: 'DriverDetails',
    //   hidden: true,
    //   meta: { title: 'DriverDetails', parent: addInfo, activeMenu: '/driver/manage-driver', enableBack: true, backPage: 'ManageDriver' }
    // },
    // {
    //   path: 'driver-inquiry',
    //   component: () => import('@/views/driver/DriverInquiry/driver-inquiry'),
    //   name: 'DriverInquiry',
    //   meta: { title: 'DriverInquiry', parent: addInfo }
    // },
  ]
}

export default driverCareRouter
